<template>
  <swiper-container
    component-name="carousel-bath-concept-concept"
    ref="tpl_root"
    init="false"
    class="text-center text-skin-base"
    events-prefix="swiper-"
  >
    <!-- SLIDE 1 -->
    <swiper-slide class="flex flex-col items-center">
      <header class="flex flex-col gap-xs">
        <div class="text-overline" v-html="$t.labels.bath_concept"></div>
        <div class="text-heading-5" v-html="concept.base.block_1.title"></div>
      </header>
      <div class="mt-lg flex flex-col items-center gap-lg">
        <div class="aspect-1/1 max-w-[180px] w-2/3">
          <media
            v-bind="concept.base.block_1.media"
            class="w-full h-full object-cover"
            reveal="fade-from-bottom"
            :sizes="{
              base: 180,
            }"
          />
        </div>
        <div
          class="text-body desktop:text-body-big text-balance"
          v-html="concept.base.block_1.text"
        ></div>
      </div>
      <footer
        class="mt-lg desktop:mt-xl flex flex-col items-center gap-xl desktop:gap-2xl"
      >
        <btn-pill
          :title="$t.labels.next"
          class="mx-auto"
          @click="handleNextSlide()"
        />
        <btn-nav :title="$t.labels.skip" @click="emit('close')" />
      </footer>
    </swiper-slide>
    <!-- end SLIDE 1 -->

    <!-- SLIDE 2 -->
    <swiper-slide class="flex flex-col items-center">
      <header class="flex flex-col gap-xs">
        <div class="text-overline" v-html="$t.labels.bath_concept"></div>
        <div class="text-heading-4" v-html="concept.base.block_2.title"></div>
      </header>
      <div class="mt-lg flex flex-col items-center gap-lg">
        <div class="aspect-1/1 max-w-[180px] w-2/3">
          <media
            v-bind="concept.base.block_2.media"
            class="w-full h-full object-cover"
            reveal="fade-from-bottom"
            :sizes="{
              base: 180,
            }"
          />
        </div>
        <div
          class="text-body desktop:text-body-big text-balance"
          v-html="concept.base.block_2.text"
        ></div>
      </div>
      <footer
        class="mt-lg desktop:mt-xl flex flex-col items-center gap-xl desktop:gap-2xl"
      >
        <btn-pill
          :title="$t.labels.next"
          class="mx-auto"
          @click="handleNextSlide()"
        />
        <btn-nav :title="$t.labels.skip" @click="emit('close')" />
      </footer>
    </swiper-slide>
    <!-- end SLIDE 2 -->

    <!-- end SLIDE 3 -->
    <swiper-slide class="flex flex-col items-center">
      <header class="flex flex-col gap-xs">
        <div class="text-overline" v-html="$t.labels.bath_concept"></div>
        <div class="text-heading-4" v-html="concept.base.block_3.title"></div>
      </header>
      <div class="mt-lg flex flex-col items-center gap-lg">
        <div class="aspect-1/1 max-w-[180px] w-2/3">
          <media
            v-bind="concept.base.block_3.media"
            class="w-full h-full object-cover"
            reveal="fade-from-bottom"
            :sizes="{
              base: 180,
            }"
          />
        </div>
        <div
          class="text-body desktop:text-body-big text-balance"
          v-html="concept.base.block_3.text"
        ></div>
      </div>
      <footer
        class="mt-lg desktop:mt-xl flex flex-col items-center gap-xl desktop:gap-2xl"
      >
        <btn-pill
          :title="$t.labels.next"
          class="mx-auto"
          @click="handleNextSlide()"
        />
        <btn-nav :title="$t.labels.skip" @click="emit('close')" />
      </footer>
    </swiper-slide>
    <!-- end SLIDE 3 -->

    <!-- SLIDE 4 -->
    <swiper-slide class="flex flex-col items-center">
      <header class="flex flex-col gap-xs">
        <div class="text-overline" v-html="$t.labels.bath_concept"></div>
        <div class="text-heading-5" v-html="concept.base.block_4.title"></div>
      </header>

      <div class="mt-md flex flex-col">
        <div class="w-full mask-tutorial">
          <div
            ref="tpl_tutorialGrid"
            class="relative top-0 left-0 flex gap-lg py-lg w-full"
          >
            <div class="w-1/3 flex flex-col gap-lg py-lg">
              <div class="w-full aspect-1/1 border border-skin-base"></div>
              <div class="w-full aspect-1/1 border border-skin-base"></div>
            </div>

            <div class="w-1/3 flex flex-col gap-lg">
              <div class="w-full aspect-1/1 border border-skin-base"></div>
              <div class="w-full aspect-1/1 border border-skin-base"></div>
            </div>

            <div class="w-1/3 flex flex-col gap-lg py-lg">
              <div class="w-full aspect-1/1 border border-skin-base"></div>
              <div class="w-full aspect-1/1 border border-skin-base"></div>
            </div>

            <span
              class="absolute inset-0 w-full h-full flex justify-center items-center"
            >
              <span
                ref="tpl_tutorialCursor"
                class="relative top-0 left-0 block aspect-1/1 border-[3px] border-[#c0c0c0] w-12 bg-black/5 rounded-full"
              ></span>
            </span>
          </div>
        </div>

        <div
          class="text-body desktop:text-body-big"
          v-html="concept.base.block_4.text"
        ></div>
      </div>

      <footer class="mt-lg desktop:mt-xl">
        <btn-pill
          :title="$t.labels.start"
          class="mx-auto"
          @click="emit('close')"
        />
      </footer>
    </swiper-slide>
    <!-- end SLIDE 4 -->
  </swiper-container>
</template>

<script setup>
import { useRootStore } from "@/stores/root";
const emit = defineEmits(["close"]);
const { width: windowW, height: windowH } = useWindowSize();
const tpl_root = templateRef("tpl_root");
const tpl_tutorialGrid = templateRef("tpl_tutorialGrid");
const tpl_tutorialCursor = templateRef("tpl_tutorialCursor");
const rootStore = useRootStore();

const concept = computed(() => {
  return rootStore.projectBathroom.value.concept;
});

const spaceBetween = computed(() => {
  let size;
  if (windowW.value >= 1020) {
    size = Math.min(Math.max(64, (windowW.value / 100) * 6.25), 120);
  } else size = Math.min(Math.max(24, (windowW.value / 100) * 4.16), 80);

  return size;
});

function handleNextSlide() {
  if (tpl_root.value?.swiper) tpl_root.value.swiper.slideNext();
}

function handleTutorialAnimation() {
  let tutorialTL = gsap.timeline({
    onComplete: () => {},
  });

  tutorialTL.fromTo(
    tpl_tutorialCursor.value,
    { top: "30%", left: "-10%", opacity: 0 },
    { duration: 0.8, top: 0, left: 0, opacity: 1, ease: "power1.out" }
  );

  tutorialTL.to(
    tpl_tutorialCursor.value,
    {
      duration: 0.4,
      background: "#6e6e6e",
      borderColor: "#6e6e6e",
      scale: 0.6,
      ease: "power1.out",
    },
    ">0.3"
  );

  tutorialTL.to(tpl_tutorialGrid.value, {
    duration: 0.7,
    xPercent: "+=9",
    yPercent: "-=6",
    ease: "circ.inOut",
  });

  tutorialTL.to(
    tpl_tutorialGrid.value,
    {
      duration: 0.85,
      xPercent: "-=25",
      yPercent: "+=15",
      ease: "power3.inOut",
    },
    ">1"
  );

  tutorialTL.to(
    tpl_tutorialGrid.value,
    {
      duration: 0.78,
      xPercent: "+=34",
      yPercent: "+=8",
      ease: "power2.inOut",
    },
    ">0.7"
  );

  tutorialTL.to(
    tpl_tutorialGrid.value,
    {
      duration: 0.6,
      xPercent: 0,
      yPercent: 0,
      ease: "sine.inOut",
    },
    ">0.7"
  );

  tutorialTL.to(
    tpl_tutorialCursor.value,
    {
      duration: 0.3,
      opacity: 0,
      scale: 0.4,
      ease: "power1.out",
    },
    ">0.15"
  );
}

useSafeMountedEl([tpl_root, tpl_tutorialGrid, tpl_tutorialCursor], () => {
  Object.assign(tpl_root.value, {
    allowTouchMove: false,
    slidesPerView: 1,
    grabCursor: false,
    speed: 450,
    autoHeight: true,
    spaceBetween: spaceBetween.value,
    on: {
      init() {
        ScrollTrigger.refresh(true);
      },
      resize(swiper) {
        if (tpl_root.value && swiper) {
          tpl_root.value.spaceBetween = spaceBetween.value;
        }
      },
      reachEnd(swiper) {
        handleTutorialAnimation();
      },
    },
  });

  tpl_root.value.initialize();
});
</script>

<style scoped>
.mask-tutorial {
  mask-repeat: no-repeat;
  mask-size: 70%;
  -webkit-mask-image: radial-gradient(
    circle,
    rgba(255, 0, 239, 1) 0%,
    rgba(255, 0, 231, 1) 25%,
    rgba(255, 0, 226, 0) 70%,
    rgba(255, 0, 226, 0) 100%
  );
  mask-image: radial-gradient(
    circle,
    rgba(255, 0, 239, 1) 0%,
    rgba(255, 0, 231, 1) 25%,
    rgba(255, 0, 226, 0) 70%,
    rgba(255, 0, 226, 0) 100%
  );
  mask-position: center;
}
</style>
